import { render, staticRenderFns } from "./mainBodyGoods.vue?vue&type=template&id=09bc7466&scoped=true&"
import script from "./mainBodyGoods.vue?vue&type=script&lang=js&"
export * from "./mainBodyGoods.vue?vue&type=script&lang=js&"
import style0 from "./mainBodyGoods.vue?vue&type=style&index=0&id=09bc7466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc7466",
  null
  
)

export default component.exports